<wl-content-section [theme]="theme()">
  @if (headingField() && videoIdField()) {
    <wl-video
      [headingField]="headingField()!"
      [videoIdField]="videoIdField()!"
      [descriptionField]="descriptionField()"
    />
  }
</wl-content-section>
